import { render } from "./PasswordSetup.vue?vue&type=template&id=a80ae8a4&scoped=true"
import script from "./PasswordSetup.vue?vue&type=script&lang=js"
export * from "./PasswordSetup.vue?vue&type=script&lang=js"

import "./PasswordSetup.vue?vue&type=style&index=0&id=a80ae8a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a80ae8a4"],['__file',"src/pages/PasswordSetup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a80ae8a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a80ae8a4', __exports__)) {
    api.reload('a80ae8a4', __exports__)
  }
  
  module.hot.accept("./PasswordSetup.vue?vue&type=template&id=a80ae8a4&scoped=true", () => {
    api.rerender('a80ae8a4', render)
  })

}


export default __exports__